// Outveil: toggles a truncated collection description between its short
// preview ("Read more") and its full text ("Read less").
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.read-more-text__toggle');
    if (!toggle) return;

    var wrapper = toggle.closest('read-more-text');
    if (!wrapper) return;

    var preview = wrapper.querySelector('.read-more-text__preview');
    var full = wrapper.querySelector('.read-more-text__full');
    var isExpanded = full && !full.hidden;

    if (isExpanded) {
      if (preview) preview.hidden = false;
      if (full) full.hidden = true;
      toggle.textContent = 'Read more';
    } else {
      if (preview) preview.hidden = true;
      if (full) full.hidden = false;
      toggle.textContent = 'Read less';
    }
  });
})();
